import { render, staticRenderFns } from "./RekeningBank.vue?vue&type=template&id=a4c510be&scoped=true&"
import script from "./RekeningBank.vue?vue&type=script&lang=js&"
export * from "./RekeningBank.vue?vue&type=script&lang=js&"
import style0 from "./RekeningBank.vue?vue&type=style&index=0&id=a4c510be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c510be",
  null
  
)

export default component.exports